import { Container, Row, Col } from 'react-bootstrap';
import Box from "../Home/Box.jsx"
import "./PrivateInstruction.css"

import DeniseHeader from "../../assets/PrivateInstruction/jpeg-optimizer_DeniseHeader.jpeg"
import Denise1 from "../../assets/PrivateInstruction/jpeg-optimizer_Denise1.jpeg"
import Denise2 from "../../assets/PrivateInstruction/jpeg-optimizer_Denise2.jpeg"
import Denise3 from "../../assets/PrivateInstruction/jpeg-optimizer_Denise3.jpeg"

export default function PrivateInstruction() {
  return (
    <div className="home-wrapper">
      <Container style={{ paddingLeft: "4vw", paddingRight: "4vw" }}>
        <Row>
            <Box title="Private Instruction" />
            <br />
            <img className="private-instruction-image" src={DeniseHeader} alt="Denise" />
            <br />
        </Row>
        <Row style={{ paddingTop: "2vh" }}>
            <p className="private-instruction-paragraph"><b>
            Denise Westby, Flute Alliance founder, is a life-long flutist who has a successful private flute instruction studio in Tigard (SW Portland), Oregon. A graduate of the University of Oregon School of Music with a degree focusing on flute performance, she combines her knowledge of performing with her love for teaching students of all ages and levels.</b>
            </p>
            <p className="private-instruction-paragraph"><b>One-on-one lessons are weekly and specialized to each students' needs. From a 30 minute lesson for a beginner (or younger player), to a 45-minute session for those progressing to 60 minutes for advanced musicians; each student will receive focused time that builds skills and creates the confidence for each player to move forward with their own flute playing goals!</b></p>
            <p className="private-instruction-paragraph"><b>Denise enjoys all styles of music and encourages the same with her students. Whether you're a school-aged player that wants to feel stronger in your band/orchestra or a professional jazz sax player who strives for a "legit" flute sound, you'll find that the Westby Flute Studio is for YOU!</b></p>
            <p className="private-instruction-paragraph private-instruction-red"><b>For further information on private lessons, including pricing and studio policies, please contact Denise:
denise.westby5@gmail.com or flutealliance@gmail.com</b></p>
            <br />
            <hr />
            <br />
        </Row>
        <Row>
          <Col>
            <img src={Denise1} className="img-fluid gallery-image" alt="Denise with Keith Underwood" />
            <br />
            <div>
              <p className="private-instruction-image-header"><b>Professionally Trained</b></p>
              <p className="private-instruction-image-text"><b>In addition to her performance degree, Denise Westby continues to take sessions with the best players and teachers. Here she is with Keith Underwood at NYU New School.</b></p>
            </div>
          </Col>
          <Col>
            <img src={Denise2} className="img-fluid gallery-image" alt="Denise teaching a student" />
            <br />
            <div style={{ alignItems: "center" }}>
              <p className="private-instruction-image-header"><b>Dedicated Student Connection</b></p>
              <p className="private-instruction-image-text"><b>Denise is dedicated to working with all students and their various learning methods. Even during pandemics!</b></p>
            </div>
          </Col>
          <Col>
            <img src={Denise3} className="img-fluid gallery-image" alt="Denise teaching" />
            <br />
            <div>
              <p className="private-instruction-image-header"><b>Musical Connections</b></p>
              <p className="private-instruction-image-text"><b>Thanks to her established connections in the musical community, the Westby Studio and Flute Alliance utilize only the best coaches and musicians!</b></p>
            </div>
          </Col>
        </Row>
      <br />
      </Container>
    </div>
  );
}
